import { render, staticRenderFns } from "./DigitalSignage.vue?vue&type=template&id=d349e838&scoped=true&"
import script from "./DigitalSignage.vue?vue&type=script&lang=ts&"
export * from "./DigitalSignage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d349e838",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VDataTable,VDialog,VForm})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d349e838')) {
      api.createRecord('d349e838', component.options)
    } else {
      api.reload('d349e838', component.options)
    }
    module.hot.accept("./DigitalSignage.vue?vue&type=template&id=d349e838&scoped=true&", function () {
      api.rerender('d349e838', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/digitalSignage/DigitalSignage.vue"
export default component.exports